export default "__VITE_ASSET__BT_LW2lr__"